import { FormGroup } from "@angular/forms";

export const validateMatchingPwd = (group: FormGroup) => {
    const pass = group.get("pwd").value;
    const confirmPass = group.get("confirmPwd").value;
    return pass === confirmPass ? null : { mismatch: true };
};
